var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinmarketcap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.2 50V49.912V49.824C99.112 22.392 76.984 0 49.984 0C22.852 0 0.764038 22.392 0.764038 50C0.764038 77.52 22.852 100 49.98 100C62.504 100 74.284 95.26 83.416 86.608C85.24 84.868 85.372 82.044 83.592 80.216C81.94 78.388 79.112 78.26 77.288 79.912C77.288 79.912 77.288 79.912 77.2 80C69.852 86.956 59.94 90.956 49.764 90.956C37.852 90.956 27.2 85.74 19.808 77.392L40.852 43.696V59.304C40.852 66.784 43.764 69.172 46.2 69.868C48.636 70.564 52.288 70.04 56.288 63.78L67.808 45.084C68.2 44.52 68.504 43.912 68.896 43.52V53C68.896 59.956 71.724 65.608 76.548 68.304C80.896 70.828 86.416 70.52 90.984 67.74C96.592 64.044 99.592 57.652 99.2 50ZM86.416 59.784C84.676 60.872 82.632 61.044 81.068 60.176C79.112 59.004 77.98 56.392 77.98 52.828V41.872C77.98 36.656 75.936 32.872 72.46 31.872C66.548 30.132 62.068 37.392 60.416 40.132L49.98 56.872V36.216C49.848 31.476 48.328 28.696 45.416 27.824C43.46 27.26 40.588 27.52 37.764 31.78L14.416 69.172C11.288 63.26 9.68004 56.696 9.68004 50C9.68004 27.436 27.812 9.088 49.984 9.088C72.16 9.088 90.288 27.436 90.288 50V50.088V50.176C90.46 54.564 89.112 58.044 86.416 59.784Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinmarketcap);
export default __webpack_public_path__ + "static/media/coinmarketcap.fc75335e96b2219dbc743b108b954b5e.svg";
export { ForwardRef as ReactComponent };